var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { createApp, createVNode } from "vue";
import "../lib/utils.js";
import _sfc_main from "../components/ui/tooltip/TooltipWrapper.js";
const tooltipMap = /* @__PURE__ */ new WeakMap();
function getPlacement(binding) {
  if (binding.modifiers.top) return "top";
  if (binding.modifiers.bottom) return "bottom";
  if (binding.modifiers.left) return "left";
  if (binding.modifiers.right) return "right";
}
__name(getPlacement, "getPlacement");
const tooltip = {
  mounted(el, binding) {
    var _a, _b;
    if (binding.value === void 0 || binding.value === null || binding.value === "" || el.dataset.tooltipProcessed) return;
    el.dataset.tooltipProcessed = "true";
    const rootContainer = document.createElement("div");
    rootContainer.style.display = "contents", el.parentElement && el.parentElement.insertBefore(rootContainer, el);
    const placement = getPlacement(binding), app = createApp({
      render() {
        return createVNode(_sfc_main, {
          content: binding.value,
          placement,
          reference: el
        }, {
          default: /* @__PURE__ */ __name(() => [createVNode("div", {
            "data-tooltip-children": !0,
            style: "display: contents;"
          }, null)], "default")
        });
      }
    });
    app.mount(rootContainer), (_b = (_a = rootContainer.querySelector("[data-tooltip-children]")) == null ? void 0 : _a.appendChild) == null || _b.call(_a, el), tooltipMap.set(el, {
      container: rootContainer,
      content: binding.value,
      placement,
      app
    });
  },
  updated(el, binding) {
    var _a, _b;
    if (binding.value === void 0 || binding.value === null || binding.value === "") return;
    const tooltipInfo = tooltipMap.get(el);
    if (!tooltipInfo) return;
    const placement = getPlacement(binding);
    if (!(tooltipInfo.content !== binding.value || tooltipInfo.placement !== placement)) return;
    el.remove(), tooltipInfo.app.unmount(), tooltipInfo.container.innerHTML = "";
    const app = createApp({
      render() {
        return createVNode(_sfc_main, {
          content: binding.value,
          placement,
          reference: el
        }, {
          default: /* @__PURE__ */ __name(() => [createVNode("div", {
            "data-tooltip-children": !0,
            style: "display: contents;"
          }, null)], "default")
        });
      }
    });
    app.mount(tooltipInfo.container), (_b = (_a = tooltipInfo.container.querySelector("[data-tooltip-children]")) == null ? void 0 : _a.appendChild) == null || _b.call(_a, el), tooltipInfo.app = app, tooltipInfo.content = binding.value, tooltipInfo.placement = placement;
  },
  unmounted(el) {
    const tooltipInfo = tooltipMap.get(el);
    tooltipInfo && (tooltipInfo.app.unmount(), tooltipInfo.container.remove()), tooltipMap.delete(el);
  }
};
export {
  tooltip as default
};
//# sourceMappingURL=tooltip.js.map
